module.exports = {
	"contract_name": "Prediction",
	"abi": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "_outcome",
					"type": "bool"
				}
			],
			"name": "resolve",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "withdrawPeriod",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "prediction",
					"type": "bool"
				}
			],
			"name": "calculatePrize",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "getState",
			"outputs": [
				{
					"name": "",
					"type": "uint8"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "outcome",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "resolved",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "withdrawFees",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "withdrawPrize",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "prediction",
					"type": "bool"
				}
			],
			"name": "bet",
			"outputs": [],
			"payable": true,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "calculateFees",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"name": "totals",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "purge",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "outcome",
					"type": "bool"
				}
			],
			"name": "getUserBalance",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "feePercent",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "resolutionTimestamp",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "betEndTimestamp",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "withdrawEndTimestamp",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "statement",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "feesWithdrawn",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "_statement",
					"type": "string"
				},
				{
					"name": "_betEndTimestamp",
					"type": "uint256"
				},
				{
					"name": "_withdrawPeriod",
					"type": "uint256"
				},
				{
					"name": "_feePercent",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "from",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "prediction",
					"type": "bool"
				},
				{
					"indexed": false,
					"name": "value",
					"type": "uint256"
				}
			],
			"name": "BetEvent",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "selectedOutcome",
					"type": "bool"
				}
			],
			"name": "ResolveEvent",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "from",
					"type": "address"
				}
			],
			"name": "WithdrawPrizeEvent",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "from",
					"type": "address"
				}
			],
			"name": "WithdrawFeesEvent",
			"type": "event"
		}
	],
	"unlinked_binary": "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",
	"networks": {},
	"schema_version": "0.0.5",
	"updated_at": 1503845106472
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Prediction.json
// module id = 337
// module chunks = 0